
import { NetworkType } from "@airgap/beacon-sdk";

export const settings = {
    
    network: {
        type: NetworkType.CUSTOM,
        rpcUrl: "/"
    },
    
    contractAddress: 'KT1MGjFWYwoU4iYSvuZisAMixcWgFBr6yX8u',
    tokenIdMin: 1,
    tokenIdMax: 4,
};
            